/**
 * The website's home page, above the fold and the trip workflow beneath it, in the words a
 * transporter uses for the work: bilty (LR), hesab, diesel cards, FASTag, e-way bill, POD.
 *
 * Every claim restates something `descriptions.ts` / `features.ts` already say the product does —
 * add a line here only when one of those supports it.
 */
export const homepageHero = {
    /** The small pill above the headline. */
    kicker: 'For transporters and fleet owners in India',
    /** The headline, in two parts: the second is set in the accent face on its own line. */
    headline: ['Bilty to payment,', 'every truck’s hesab.'],
    lead: 'Book the trip, print the bilty (LR), raise the GST invoice and collect the payment. Diesel-card fills, FASTag tolls and the driver’s hesab land on the same trip, so you see what each truck earned — and your CA gets a Tally file.',
    /** One line in Hindi under the lead, so a Hindi reader sees the page is for them. */
    hindiLine: 'ट्रिप, बिल्टी, डीज़ल, FASTag और ड्राइवर का हिसाब — सब एक ही सॉफ़्टवेयर में।',
    /** Short proof points under the calls to action. */
    proof: [
        'Bilty / LR and POD',
        'GST invoice and e-way bill',
        'BPCL and Reliance fuel cards',
        'FASTag toll history',
        'Driver app with hesab',
        'Tally export',
        'Works offline',
    ],
};
/** The trip's path through the product, as the home page tells it. */
export const homepageWorkflow = {
    eyebrow: 'From booking to hesab',
    title: 'One trip, start to finish.',
    body: 'Each step hands the next one its records, so nothing is written twice and nothing is rebuilt from a diary.',
    steps: [
        {
            title: 'Book and print the bilty',
            body: 'Pick the truck and the driver, take the fare from the party’s rate card, and print the LR on one sheet per copy.',
        },
        {
            title: 'Diesel, FASTag and POD',
            body: 'Fuel-card fills and FASTag tolls land on the trip, the driver’s phone sends photos and expenses, and pending PODs stay on your list until they are in.',
        },
        {
            title: 'Invoice and collect',
            body: 'Raise the GST invoice, prepare the e-invoice and e-way bill files for the GST portal, and see which party to call first for payment.',
        },
        {
            title: 'Settle the hesab',
            body: 'Close the driver’s hesab and each party’s ledger, read every truck’s profit in the vehicle report, and export to Tally for your CA.',
        },
    ],
};
//# sourceMappingURL=homepage.js.map